import React, { useEffect, useState } from "react";

import { numberWithCommas } from "helpers/miscHelpers";

import {
  StyledCountyDiv,
  StyledCountyResults,
  StyledCountySearch,
  StyledCountySummary,
} from "./styles";

import CountyChart from "./CountyHolder";

function injectDataNewCases(data) {
  const { confirmed } = data.timeline;
  const newCases = {};
  const caseKeys = Object.keys(confirmed);

  caseKeys.forEach((c, j) => {
    const val =
      j === 0 ? 0 : confirmed[`${c}`] - confirmed[`${caseKeys[j - 1]}`];
    Object.assign(newCases, { [`${c}`]: val });
  });

  data.timeline.newCases = newCases;
}

function injectDataNewDeaths(data) {
  const { deaths } = data.timeline;
  const newDeaths = {};
  const theKeys = Object.keys(deaths);

  theKeys.forEach((c, j) => {
    const val = j === 0 ? 0 : deaths[`${c}`] - deaths[`${theKeys[j - 1]}`];
    Object.assign(newDeaths, { [`${c}`]: val });
  });

  data.timeline.newDeaths = newDeaths;
}

const CountySearch = ({ data }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState({});
  const [selectedLoc, setSelectedLoc] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [latestDate, setLatestDate] = useState(null);
  const [chartType, setChartType] = useState("confirmed");

  useEffect(() => {
    function makeChartData(loc) {
      if (loc) {
        const foundConfirmed = data.confirmed.find(x => x.Combined_Key === loc);
        const foundDeaths = data.deaths.find(x => x.Combined_Key === loc);
        const dateFields = Object.keys(foundConfirmed).filter(x =>
          x.includes("/")
        );
        setLatestDate(dateFields.slice(-1)[0]);

        const confirmedObj = {};
        const deathsObj = {};

        dateFields.forEach(df => {
          Object.assign(confirmedObj, {
            [`${df}`]: Number(foundConfirmed[`${df}`]),
          });
          Object.assign(deathsObj, { [`${df}`]: Number(foundDeaths[`${df}`]) });
        });

        const newObj = {
          name: foundConfirmed.Combined_Key,
          timeline: {
            confirmed: confirmedObj,
            deaths: deathsObj,
          },
        };

        injectDataNewCases(newObj);
        injectDataNewDeaths(newObj);

        setChartData(newObj);
      }
    }

    makeChartData(selectedLoc);
  }, [data.confirmed, data.deaths, selectedLoc]);

  useEffect(() => {
    function filterData(term) {
      if (data && data.confirmed.length > 0) {
        const filteredConfirmed = data.confirmed.filter(x => {
          if (term.length < 3) {
            return false;
          }

          const countyName = x.Combined_Key ? x.Combined_Key.toLowerCase() : "";
          if (countyName && countyName.includes(term)) {
            return true;
          }

          return false;
        });
        // console.log("filteredConfirmed: ", filteredConfirmed);

        const filteredDeaths = data.deaths.filter(x => {
          if (term.length < 3) {
            return false;
          }
          if (x.Combined_Key && x.Combined_Key.toLowerCase().includes(term)) {
            return true;
          }

          return false;
        });

        // console.log("filterData -> filteredDeaths", filteredDeaths);
        setFilteredData({
          confirmed: filteredConfirmed,
          deaths: filteredDeaths,
        });
      }
    }

    filterData(searchTerm.toLowerCase());
  }, [data, searchTerm]);

  return (
    <StyledCountyDiv>
      <h2>County Data:</h2>

      <div className="countyFlexUI">
        <div className="leftside">
          <StyledCountySearch>
            <input
              type="text"
              name="csearch"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              placeholder="Start Typing County"
            />

            <button
              type="button"
              name="cclear"
              onClick={() => {
                setSearchTerm("");
                setChartData(null);
                setSelectedLoc(null);
              }}
            >
              clear
            </button>
          </StyledCountySearch>
          <p
            style={{
              fontSize: "11px",
              textAlign: "center",
              marginBottom: 0,
              paddingBottom: 0,
            }}
          >
            * If the data seems to be missing for your county (e.g. Kings NY)
            try typing the state name and then look thru the choices below.
          </p>

          {filteredData.confirmed && filteredData.confirmed.length > 0 && (
            <StyledCountyResults>
              <p>Click a location below for details:</p>
              <ul>
                {filteredData.confirmed.map((c, i) => (
                  <li key={i}>
                    <button
                      type="button"
                      onClick={() => setSelectedLoc(c.Combined_Key)}
                    >
                      {c.Combined_Key}
                    </button>
                  </li>
                ))}
              </ul>
            </StyledCountyResults>
          )}
        </div>

        {chartData && chartData.timeline && (
          <StyledCountySummary>
            <h3>Location: {chartData.name}</h3>

            <div className="items">
              <div>
                Total Cases:{" "}
                <span>
                  {numberWithCommas(
                    chartData.timeline.confirmed[`${latestDate}`]
                  )}
                </span>
              </div>
              <div>
                Total Deaths:{" "}
                <span>
                  {numberWithCommas(chartData.timeline.deaths[`${latestDate}`])}
                </span>
              </div>
              <div>
                New Cases:{" "}
                <span>
                  {numberWithCommas(
                    chartData.timeline.newCases[`${latestDate}`]
                  )}
                </span>
              </div>
              <div>
                New Deaths:{" "}
                <span>
                  {numberWithCommas(
                    chartData.timeline.newDeaths[`${latestDate}`]
                  )}
                </span>
              </div>
            </div>
          </StyledCountySummary>
        )}

        <div className="rightside">
          {chartData && chartData.timeline && (
            <CountyChart
              aspectRatio={0.5}
              chartType={chartType}
              dateCount={20}
              loadedData={chartData}
              setChartType={setChartType}
            />
          )}
        </div>
      </div>
    </StyledCountyDiv>
  );
};

export default CountySearch;
